import { compose } from '@bem-react/core';
import {
    Textinput as TextInputPresenter,
    withHasClear,
    withSizeM,
    withThemeNormal,
    withViewClassic
} from '@yandex-lego/components/Textinput/desktop';

const Textinput = compose(
    withViewClassic,
    withThemeNormal,
    withHasClear,
    withSizeM
)(TextInputPresenter);

export default Textinput;
